module.exports = __webpack_public_path__ + "img/27.c9cee4ed.jpg";